// extracted by mini-css-extract-plugin
export default {"form":"AddedNewWords_form__JTbII","input":"AddedNewWords_input__ha-3N","submit":"AddedNewWords_submit__8PfNI"};